import { fetchWrapper } from "@helpers/fetchwrapper";

export function fetchCareerGuidanceByHolland(
  hollandApi,
  { offset = 0, limit = 50, oksoCode = "", type } = {}
) {
  const params = new URLSearchParams({
    Offset: String(offset),
    Limit: String(limit),
  });

  Object.entries(hollandApi || {}).forEach(([key, value]) => {
    if (value != null && Number(value) > 0) {
      params.set(key, String(value));
    }
  });

  if (oksoCode) {
    params.set("OksoCode", oksoCode);
  }

  if (type != null) {
    params.set("Type", String(type));
  }

  return fetchWrapper.get(
    `/v1/api/app/FindCareerGuidanceByHolland?${params.toString()}`
  );
}

export function fetchCompaniesWithFaculty({
  text = "",
  types = [2, 3],
  limit = 10,
  offset = 0,
  faculty = [],
} = {}) {
  const data = { text, types, limit, offset };

  if (faculty.length > 0) {
    data.faculty = faculty;
  }

  return fetchWrapper.post("/v1/api/app/findCompaniesWithFaculty", data);
}

export function fetchCompaniesWithFacultyByCodes({
  text = "",
  types = [2, 3],
  limit = 10,
  offset = 0, 
  faculty = [],
} = {}) {
  const data = { text, types, limit, offset };

  if (faculty.length > 0) {
    data.faculty = faculty;
  }

  return fetchWrapper.post(
    "/v1/api/app/FindCompaniesWithFacultyByCodes",
    data
  );
}

export function fetchCompaniesWithSpecialistNeeds({
  text = "",
  limit = 100,
  offset = 0,
} = {}) {
  return fetchWrapper.post(
    "/v1/api/app/FindCompaniesWithPracticesAndMentorshipsAndSpecialistNeeds",
    {
      text,
      limit,
      offset,
      CoordinateSize: 3,
    }
  );
}

export function fetchCompaniesBySpecialistNeeds({
  specIds = [],
  limit = 100,
  offset = 0,
  coordinateSize = 3,
} = {}) {
  return fetchWrapper.post("/v1/api/app/FindCompaniesBySpecialistNeeds", {
    SpecIds: specIds,
    Limit: limit,
    Offset: offset,
    CoordinateSize: coordinateSize,
  });
}

/**
 * Достаёт SpecIds из выдачи FindCareerGuidanceByHolland.
 * Берёт только записи с MatchScore > minMatchScore, по убыванию score,
 * уникальные Id — иначе при Limit=100 Type=3 отдаёт весь Holland-пул (~86)
 * и компании перестают зависеть от профиля теста.
 */
export function extractSpecialistNeedIds(
  items,
  { limit = Infinity, minMatchScore = 0 } = {}
) {
  const ranked = (items || [])
    .filter(
      (item) =>
        item.SpecialistNeedsItemId != null &&
        Number(item.MatchScore || 0) > minMatchScore
    )
    .sort(
      (a, b) => Number(b.MatchScore || 0) - Number(a.MatchScore || 0)
    );

  const ids = [];
  const seen = new Set();

  for (const item of ranked) {
    const id = Number(item.SpecialistNeedsItemId);
    if (seen.has(id)) continue;
    seen.add(id);
    ids.push(id);
    if (ids.length >= limit) break;
  }

  return ids;
}

export function buildCareerSearchText(items, limit = 5) {
  const titles = [];

  (items || []).forEach((item) => {
    [item.OksoTitle, item.OkzTitle, item.SpecialistNeedsItem]
      .filter(Boolean)
      .forEach((title) => {
        const normalized = title.trim();
        if (normalized && !titles.includes(normalized)) {
          titles.push(normalized);
        }
      });
  });

  return titles.slice(0, limit).join(" ");
}

/**
 * Сохраняет результат прохождения профтеста (опросник Холланда) на сервере.
 *
 * На сервер отправляются:
 *  - код Холланда (hollandCode) и упорядоченный список типов (sortedTypes);
 *  - баллы по каждому типу (scores.total);
 *  - нормализованные значения для подбора (hollandApi);
 *  - дата и время прохождения (completedAt, ISO-8601);
 *  - версия опросника (version) и исходные ответы (answers).
 *
 * IP-адрес пользователя определяется на стороне сервера
 * (X-Forwarded-For / X-Real-IP / req.socket.remoteAddress).
 *
 * @param {object} hollandData - результат, полученный из buildHollandPairResultPayload.
 * @returns {Promise<object>} ответ сервера с сохранённой записью.
 */
export function saveHollandResultToServer(hollandData) {
  return fetchWrapper.post("/v1/api/app/SaveHollandResult", hollandData);
}

